import React, { type PropsWithChildren } from 'react';
import {
	FilterGroupTitle,
	SkeletonContainer,
	FilterGroupContainer,
	FilterResultRowContainer,
} from './filter-group.styled';
import { SkeletonItem, type AvatarShape } from '../search-skeleton';

export type Props = PropsWithChildren<{
	/**
	 * The title of the filter props
	 */
	title: string;
	/**
	 * Whether the filters are currently being loaded. This will render a set of placeholder loading filter items.
	 */
	isLoading?: boolean;
	/**
	 * The shape of the filter icons / avatars. This is used with the placeholder loading filter items and preferably match the icon shape of the actual filter items.
	 * This defaults to no avatar.
	 */
	avatarShape?: AvatarShape;
}>;

export const ColumnFilterGroup = ({ children, title, isLoading, avatarShape }: Props) => {
	return (
		<FilterGroupContainer>
			<FilterGroupTitle>{title}</FilterGroupTitle>
			{!isLoading ? (
				children
			) : (
				<SkeletonContainer>
					<SkeletonItem avatarShape={avatarShape} isShimmering />
					<SkeletonItem avatarShape={avatarShape} isShimmering />
					<SkeletonItem avatarShape={avatarShape} isShimmering />
				</SkeletonContainer>
			)}
		</FilterGroupContainer>
	);
};

export const RowFilterGroup = ({ children, title, isLoading, avatarShape = 'none' }: Props) => {
	return (
		<FilterGroupContainer>
			<FilterGroupTitle>{title}</FilterGroupTitle>
			<FilterResultRowContainer>
				{!isLoading ? (
					children
				) : (
					<SkeletonContainer>
						<SkeletonItem avatarShape={avatarShape} isShimmering />
					</SkeletonContainer>
				)}
			</FilterResultRowContainer>
		</FilterGroupContainer>
	);
};
